module.exports = __webpack_public_path__ + "static/media/img8.5ba2007d.jpg";